if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.target = document.getElementById(this.dataset.target);
        this.button = this.querySelector('button');
        if (!this.target || !this.button || !('IntersectionObserver' in window)) return;

        // Watch the whole buy-buttons area so the bar hides as soon as any of it is on screen
        const watched = this.target.closest('.product-form__buttons') || this.target;
        this.observer = new IntersectionObserver(([entry]) => this.toggle(!entry.isIntersecting));
        this.observer.observe(watched);

        this.button.addEventListener('click', () => {
          if (this.target.disabled) {
            this.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          this.target.click();
        });

        // The Forms embed attaches its shadow content a few seconds after load; retry briefly
        let tries = 0;
        this.lateEmbeds = setInterval(() => {
          if (this.liftFormsTeaser(!this.hidden) || ++tries > 20) clearInterval(this.lateEmbeds);
        }, 1000);

        // Keep the label / disabled state in sync with the main button
        this.mutations = new MutationObserver(() => this.sync());
        this.mutations.observe(this.target, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mutations) this.mutations.disconnect();
        clearInterval(this.lateEmbeds);
        document.body.classList.remove('raptic-sticky-atc-visible');
      }

      toggle(show) {
        this.hidden = !show;
        document.body.classList.toggle('raptic-sticky-atc-visible', show);
        this.liftFormsTeaser(show);
      }

      // The Shopify Forms teaser pill is position:fixed inside an open shadow root at max
      // z-index, so page CSS cannot reach it. Give it one rule that follows a custom property
      // set on the host; if the app changes its markup this silently does nothing.
      liftFormsTeaser(show) {
        try {
          const host = document.querySelector('shopify-forms-embed');
          if (!host || !host.shadowRoot || !host.shadowRoot.querySelector('[class*="appEmbedRoot"]')) return false;
          if (!host.shadowRoot.getElementById('raptic-lift')) {
            const style = document.createElement('style');
            style.id = 'raptic-lift';
            style.textContent =
              '[class*="appEmbedRootTeaser"]{translate:0 calc(-1 * var(--raptic-lift, 0px)) !important}';
            host.shadowRoot.appendChild(style);
          }
          host.style.setProperty('--raptic-lift', show && window.innerWidth < 750 ? `${this.offsetHeight}px` : '0px');
          return true;
        } catch (e) {
          /* never let a third-party widget break add to cart */
          return true;
        }
      }

      sync() {
        this.button.disabled = this.target.disabled;
      }
    }
  );
}
